const REGULAR_TAX_INCLUDE_PRICE_ELEMENT_ID = 'regularOrderSalesPriceTaxInclude';
const LARGE_COMMERCIAL_PACK_TAX_INCLUDE_PRICE_ELEMENT_ID = 'salesPriceTaxInclude';
const GREAT_VALUE_PRICE_ELEMENT_ID = 'greatValuePrice';

export class GreatValuePriceUtil {
    static reRenderGreatValuePrice() {
        const regularTaxIncludePriceElement: HTMLElement | null = document.getElementById(REGULAR_TAX_INCLUDE_PRICE_ELEMENT_ID);
        const largeCommercialPackTaxIncludePriceElement: HTMLElement | null = document.getElementById(LARGE_COMMERCIAL_PACK_TAX_INCLUDE_PRICE_ELEMENT_ID);
        const greatValuePriceElement: HTMLElement | null = document.getElementById(GREAT_VALUE_PRICE_ELEMENT_ID);

        if (regularTaxIncludePriceElement == null ||
            largeCommercialPackTaxIncludePriceElement == null ||
            greatValuePriceElement == null) {
            return;
        }

        // 大業パの税込金額を取得
        const largeCommercialPackTaxIncludePrice = this.convertLocalStringToNumber(largeCommercialPackTaxIncludePriceElement.innerHTML);
        // 定期便の税込金額を取得
        const regularTaxIncludePrice = this.convertLocalStringToNumber(regularTaxIncludePriceElement.innerHTML);
        // 定期便のお得な金額を算出
        const greatValuePrice = largeCommercialPackTaxIncludePrice - regularTaxIncludePrice;

        if (greatValuePrice > 0) {
            greatValuePriceElement.innerHTML = `￥${greatValuePrice.toLocaleString()}お得`;
            greatValuePriceElement.style.display = '';
        } else {
            greatValuePriceElement.style.display = 'none';
        }
    }

    // ￥3,280を3280に変換
    private static convertLocalStringToNumber(localString: string): number {
        return Number(localString.replace('￥', '').replace(/,/g, ''))
    }
}
